import { ApiType } from "@gymflow/common";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { availabilityQueryKeys } from "./availabilityQueryKeys";

export function useQueryFacilityAvailabilityOverrideList(
  {
    api,
    facilityId,
    opts,
  }: {
    api: ApiType;
    facilityId?: number;
    opts: Parameters<ApiType["availabilityApi"]["listFacilityOverride"]>[1];
  },
  queryOpts?: Omit<
    UseQueryOptions<
      Awaited<
        ReturnType<ApiType["availabilityApi"]["listFacilityOverride"]>
      >["data"]
    >,
    "queryKey"
  >,
) {
  const result = useQuery({
    queryKey: availabilityQueryKeys.listFacilityOverrides(
      facilityId as number,
      opts,
    ),
    queryFn: async () => {
      const result = await api.availabilityApi.listFacilityOverride(
        facilityId!,
        opts,
      );
      return result.data;
    },
    enabled: !!facilityId,
    ...queryOpts,
  });

  return result;
}
